// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"tba-z"};